import * as React from "react";
import { Grid, SemanticWIDTHS } from "semantic-ui-react";

export interface DetailGroupProps {
    header?: string | JSX.Element;
    width?: SemanticWIDTHS;
}

export const DetailGroup: React.SFC<DetailGroupProps> = ({ children, header, width }) => (
    <Grid className="detail-group">
        {header !== undefined && (
            <Grid.Row>
                <Grid.Column as="h2" width={width || 16}>
                    {header}
                </Grid.Column>
            </Grid.Row>
        )}
        {children}
    </Grid>
);
